import { Component } from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {ProductMeta} from "../../app/classes/product_meta";

/*
  Generated class for the ProductSize page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-product-size',
  template: `
    <ion-list radio-group [(ngModel)]="productSize" class="popover-page">
     <ion-item *ngFor="let size of sizes; let i = index;">
       <ion-label>{{size.name}} <span style="float: right">{{size.price | currency:'EUR':true}}</span></ion-label>
        <ion-radio value="{{i}}"></ion-radio>
      </ion-item>
      <ion-row>
        <ion-col>
            <button small clear ion-button (click)="dismiss()">
              Abbrechen
            </button>
            <button small ion-button (click)="selectSize()">
              Auswählen
            </button>
        </ion-col>
      </ion-row>
    </ion-list>
  `


})
export class ProductSizePage {
  public productSize : any = false;
  public sizes : ProductMeta[] = [];
  constructor(public navCtrl: NavController, public viewCtrl : ViewController, public navParams: NavParams) {
    this.sizes = navParams.get("sizes") as ProductMeta[];
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProductSizePage');
  }

  changeProductSize(){

  }

  selectSize(){
    this.viewCtrl.dismiss(parseInt(this.productSize));
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/product-size/product-size.ts